import { CareerId } from '@common/const/catalog/career';
import { enumKeysToArray } from '@cp/utils/common/enumKeysToArray';
import { FormAvailableOnlyFieldName } from 'src/entities/catalog/ui/availableOnly/model';
import { FORM_FIELDS_BASE, FORM_FIELDS_FOR_CAREER, FormFieldName } from '../form';

export const getFieldNames = ({ careerId }: { careerId: CareerId }): (FormFieldName | FormAvailableOnlyFieldName)[] => {
  const fieldNames: FormFieldName[] = [...FORM_FIELDS_BASE];
  const fieldNamesForCareer = FORM_FIELDS_FOR_CAREER[careerId];
  const faofNames = enumKeysToArray(FormAvailableOnlyFieldName).map((key) => FormAvailableOnlyFieldName[key]);

  if (fieldNamesForCareer) {
    fieldNames.push(...fieldNamesForCareer);
  }

  return [...fieldNames, ...faofNames];
};
